import React from 'react';
import ReactPlayer from 'react-player/youtube';
import { ChevronRight, CalendarIcon } from 'lucide-react';
export function HeroSection() {
  return <section className="relative min-h-[80vh] overflow-hidden pt-32" data-id="element-108">
      {/* YouTube Video Background */}
      <div className="absolute inset-0 w-full h-full overflow-hidden z-0" data-id="element-109">
        <ReactPlayer url="https://www.youtube.com/watch?v=f_7BRyOFgb0" playing loop muted width="100%" height="100%" className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2" style={{
        minWidth: '177.77vh',
        minHeight: '56.25vw',
        pointerEvents: 'none'
      }} config={{
        youtube: {
          playerVars: {
            autoplay: 1,
            controls: 0,
            rel: 0,
            showinfo: 0,
            mute: 1,
            loop: 1,
            playlist: 'f_7BRyOFgb0',
            modestbranding: 1,
            playsinline: 1
          }
        }
      }} data-id="element-110" />
      </div>

      {/* Dark Overlay */}
      <div className="absolute inset-0 bg-black/50 z-10" data-id="element-111" />

      {/* Content */}
      <div className="max-w-4xl mx-auto text-center relative z-20 px-6 sm:px-8 h-full flex flex-col justify-center py-20" data-id="element-112">
        <div className="w-16 h-0.5 bg-brand-pink mx-auto mb-6" data-id="element-113" />
        <div className="text-brand-pink text-xs tracking-[0.4em] font-light uppercase mb-4" data-id="element-114">
          Welcome
        </div>
        <h1 className="text-4xl md:text-5xl lg:text-6xl font-serif text-white mb-6 leading-tight" data-id="element-115">
          Experience Premium Sparkling Wines
        </h1>
        <p className="text-xl text-white mb-10 leading-relaxed max-w-2xl mx-auto" data-id="element-116">
          Discover Peterson House: Bubbles, Bites, and Beautiful Weddings
        </p>
        <div className="flex flex-col sm:flex-row gap-4 justify-center items-center" data-id="element-117">
          <button className="inline-flex items-center gap-2 bg-white text-brand-grey px-8 py-3 hover:bg-neutral-100 transition-colors font-medium rounded-none group" data-id="element-118">
            <CalendarIcon size={18} data-id="element-119" />
            Book Cellar Door
            <ChevronRight size={16} className="group-hover:translate-x-1 transition-transform duration-200" data-id="element-120" />
          </button>
          <button className="inline-flex items-center gap-2 border-2 border-white text-white px-8 py-3 hover:bg-white hover:text-brand-grey transition-colors font-medium rounded-none group" data-id="element-121">
            <CalendarIcon size={18} data-id="element-122" />
            Book Restaurant
            <ChevronRight size={16} className="group-hover:translate-x-1 transition-transform duration-200" data-id="element-123" />
          </button>
        </div>
      </div>
    </section>;
}